import React, {} from 'react';

import '../layout/sass/_responsiveTable.scss'
import '../layout/sass/_dashboard.scss';

import { TabelaEmpenho } from './TabelaEmpenho';

export const DashBoard = () => {

    return (
        <>
        <TabelaEmpenho filter={true} />
        </>
    );
}
